// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { IconWrapper } from "@insite/mobius/Icon";
import { productAvailabilityStyles } from "@turnerBlueprint/Overrides/Components/ProductAvailability";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { css } from "styled-components";

productAvailabilityStyles.container = {
    ...productAvailabilityStyles.container,
    offsetCss: css`
        row-gap: 4px;
    `,
};
productAvailabilityStyles.errorText = {
    weight: fontConfig.weight.bold,
    size: 12,
    color: "danger",
    lineHeight: "15px",
};

productAvailabilityStyles.messageText = {
    size: 12,
    lineHeight: "14px",
    css: css`
        width: 100%;
        // ${wrapInContainerStyles}
        white-space: nowrap;
        letter-spacing: 0;
    `,
};

productAvailabilityStyles.inventoryMessage = {
    css: css`
        display: flex;
        gap: 4px;
        align-items: center;
        background: none;
        ${IconWrapper}, svg {
            width: 12px;
            height: 13px;
        }
    `,
};

productAvailabilityStyles.availabilityByWarehouseModal = {};
productAvailabilityStyles.messageGridItem = { width: [12, 12, 12, 6, 6] };
productAvailabilityStyles.availabilityByWarehouseLinkGridItem = { width: [12, 12, 12, 6, 6] };
